import SkeletonLoading from '../../../../../shared/components/Loading/SkeletonLoading';

export default function ReviewModalImageSkeleton() {
  return <SkeletonLoading width={375} height={488} radius={6} />;
}
